import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectStore = ({ analytics }) => analytics;

const makeSelectCompact = () => createSelector(
  selectStore,
  ({ compact }) => compact,
);

const makeSelectPageFilters = (page) => createSelector(
  selectStore,
  (state) => R.path([page, 'filters'], state),
);

const makeSelectPageOptions = (page) => createSelector(
  selectStore,
  (state) => R.path([page, 'options'], state),
);

export {
  makeSelectCompact,
  makeSelectPageFilters,
  makeSelectPageOptions,
};

const emptyReports = {};

export const makeSelectPageReports = (page) => createSelector(
  selectStore,
  (state) => R.pathOr(emptyReports, [page, 'reports'], state),
);

export const makeSelectExpanded = (page) => createSelector(
  selectStore,
  (state) => R.pathOr(null, [page, 'expanded'], state),
);

export const makeSelectSyncStatus = (branch) => createSelector(
  selectStore,
  (state) => R.pathOr(null, ['syncStatus', branch || 'default', 'data'], state),
);

export const makeSelectReport = (page, key) => createSelector(
  selectStore,
  (state) => R.path([page, 'reports', key], state),
);

export const makeSelectDetail = (page, key, rowKey) => createSelector(
  selectStore,
  (state) => R.path([page, 'reports', key, 'details', rowKey], state),
);

export const makeSelectOptionList = (page, key) => createSelector(
  selectStore,
  (state) => R.path([page, 'options', key], state),
);

export const makeSelectSyncRequest = (branch) => createSelector(
  selectStore,
  (state) => R.path(['syncStatus', branch || 'default'], state),
);
